import { gqlOperation } from '…/app/common/rpc/gqlOperation.mts';

import SEARCH_WORKSPACES from './searchWorkspaces.gql';

interface SearchWorkspacesResponse {
  allWorkspaces: {
    id: string;
    name: string;
  }[];
}

export function searchWorkspaces({
  search,
}: {
  search: string;
}): Promise<SearchWorkspacesResponse['allWorkspaces']> {
  return gqlOperation<SearchWorkspacesResponse>(SEARCH_WORKSPACES, {
    search,
  }).then(({ allWorkspaces }) => allWorkspaces);
}
